import { sendAnalyticLoginEmailClick, sendAnalyticLoginPasswordClick } from 'services/analytics';

import passwordIcon from 'assets/img/icons/passwordIcon.svg';
import emailIcon from 'assets/img/icons/emailIcon.svg';

export const CONTENT = [
    {
        name: 'email',
        label: 'input.email.placeholder',
        type: 'email',
        icon: emailIcon,
        dataLocator: 'loginEmailInput',
        placeholder: 'input.email.placeholder',
        analyticHandler: sendAnalyticLoginEmailClick,
    },
    {
        name: 'password',
        label: 'input.password.label',
        type: 'password',
        icon: passwordIcon,
        dataLocator: 'loginPasswordInput',
        placeholder: 'input.password.placeholder',
        analyticHandler: sendAnalyticLoginPasswordClick,
    },
] as const;
